var map = {
	"./033-bm.webp": 1253,
	"./033-cn.webp": 1254,
	"./033.webp": 1255,
	"./13-bm.webp": 1256,
	"./13-cn.webp": 1257,
	"./13.webp": 1258,
	"./3-bm.webp": 1259,
	"./3-cn.webp": 1260,
	"./3.webp": 1261,
	"./angpao-bm.webp": 1262,
	"./angpao-cn.webp": 1263,
	"./angpao.webp": 1264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1252;